<template>
  <div class="resort-item__slider">
    <cabin-image-carousel :images="images" v-if="images.length > 0" :class="{'allow-border-image': !hasBookingTerm}" />

    <image-with-fallback
      v-else
      class="resort-image rounded"
      :src="resort.__platform_image"
      :alt="resort.__platform_name"
    />

    <div class="booking-term flex items-center rounded-bl rounded-br px-2" v-if="hasBookingTerm">
      <booking-term-icon :type="bookingTerm.type" />
      <span class="flex-1 fs-14 ml-2">{{ bookingTerm.title }} booking terms</span>
      <svg class="icon-question text-white cursor-pointer" fill="currentColor" width="20" height="20" @click="openModal">
        <use xlink:href="/img/sprite.svg#ic_question" />
      </svg>
    </div>

    <zb-modal
      no-padding
      ref="bookingTermModal"
      class="slide-in-modal booking-term-modal"
      v-if="hasBookingTerm"
    >
      <template v-slot:title>
        <div class="font-medium text-base flex items-center">
          <booking-term-icon :type="bookingTerm.type" class="text-blue mr-2" />
          {{ bookingTerm.title }} booking terms
        </div>
      </template>
      <template v-slot:default>
        <div
          v-html="bookingTermDescription"
          class="p-6 booking-term-modal-body"
        />
      </template>
    </zb-modal>
  </div>
</template>

<script>
import ImageWithFallback from '../core/ImageWithFallback'
import CabinImageCarousel from './../../views/liveaboard/CabinImageCarousel'
import BookingTermIcon from "./mixins/BookingTermIcon";

export default {
  name: 'SearchItemImages',
  props: ['resort'],
  components: {
    ImageWithFallback,
    BookingTermIcon,
    CabinImageCarousel
  },
  computed: {
    images() {
      return this.resort.__platform_gallery || []
    },
    hasBookingTerm() {
      return typeof this.resort.__odyssey_booking_terms === 'object'
    },
    bookingTerm() {
      return this.hasBookingTerm ? this.resort.__odyssey_booking_terms : {}
    },
    bookingTermDescription() {
      return this.resort.__odyssey_cancelation_policy || this.bookingTerm.description
    }
  },
  methods: {
    openModal() {
      this.$refs.bookingTermModal.show()
    }
  }
}
</script>

<style scoped>
.booking-term {
  background: var(--blue);
  color: white;
  height: 30px;
}

.booking-term-modal-body ol,
.booking-term-modal-body ul {
  list-style: initial;
  margin-block-start: 1em;
  padding-inline-start: 40px;
}
.booking-term-modal-body ol li,
.booking-term-modal-body ul li {
  margin-bottom: 0.5rem;
}
.booking-term-modal-body ol {
  list-style-type: decimal;
}
.booking-term-modal ::v-deep .zb-modal-title-container {
  border-radius: 4px;
  padding: 0.5rem 1rem;
  background: var(--blue-light-3);
}
.booking-term-modal ::v-deep  .zb-modal-title-container .zb-modal-close {
  padding: 0;
}

::v-deep .allow-border-image .cover-image{
  border-radius: 0.25rem;
}
</style>
